import React, { useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import ChatHeader from '../components/Chat/ChatHeader';
import MessageList from '../components/Chat/MessageList';
import ChatInput from '../components/Chat/ChatInput';
import Sidebar from '../components/Chat/Sidebar';
import { useAuth } from '../hooks/useAuth';
import { useChat } from '../hooks/useChat';
import './ChatPage.css';

const ChatPage = () => {
    const { authToken, phoneNumber, isAuthLoading } = useAuth();
    const {
        messages,
        isLoading,
        conversations,
        selectedChat,
        handleSendMessage,
        handleChatClick,
        handleInicioClick,
    } = useChat(authToken, phoneNumber);

    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const handleSelectChatAndClose = (url) => {
        handleChatClick(url);
        setSidebarOpen(false);
    };
    
    const handleNewChatAndClose = (e) => {
        handleInicioClick(e);
        setSidebarOpen(false);
    };

    if (isAuthLoading) {
        return <div className="loading-full-page">Verifying session...</div>;
    }

    return (
        <div className="chat-page-layout">
            <Sidebar
                isOpen={isSidebarOpen}
                onClose={() => setSidebarOpen(false)}
                conversations={conversations}
                selectedChat={selectedChat}
                onNewChatClick={handleNewChatAndClose}
                onChatClick={handleSelectChatAndClose}
            />
            <div className="chat-container">
                <div className="chat-header">
                    <button className="menu-button" onClick={() => setSidebarOpen(true)}>
                        <FiMenu size={18} />
                    </button>
                    {/* El título se mueve al componente ChatHeader */}
                    <ChatHeader />
                </div>
                <MessageList messages={messages} isLoading={isLoading} />
                <ChatInput onSendMessage={handleSendMessage} isLoading={isLoading}/>
            </div>
            {/* footter */}
            <div
                style={{
                    textAlign: "center",
                    padding: "10px",
                    backgroundColor: "#1e3a8a",
                    color: "white",
                    fontSize: "14px",
                    position: "fixed",
                    bottom: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "100%",
                    maxWidth: "780px",
                    zIndex: 1000,
                }}
                >
                power by worlddata © 2025
            </div>

        </div>
    );
};

export default ChatPage;